import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import MessagesReducer from './MessagesReducer';
import BlogReducer from './BlogReducer';

const AllReducers = combineReducers({
  Auth: AuthReducer,
  Messages: MessagesReducer,
  SingleBlog: BlogReducer,
});

export default AllReducers;
